import React from "react";
import "./doc.scss";
import { Link } from "react-router-dom";
import error from '../images/error.svg'
const Doc = () => {
  
  return (
    <>
      <div className="mt-40 text-center text-green-200 font-face-nh text-3xl">
        <img src={error} alt="Error" className="ml-[30vw] w-[40vw] h-[40vh]"/>
        <p className="mb-4 mt-5">Page not found</p>
        <Link to='/' className="underline">Go Home</Link>
      </div>
    </>
  );
};

export default Doc;
